import { render } from "./Loader.vue?vue&type=template&id=c6cc3664&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=c6cc3664&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-c6cc3664"

export default script